import { isFrench } from '~utils/locale';

export function getBrand(process = window.process) {
  if (process && process.env) {
    return process.env.WHITELABEL_BRAND;
  }
  return 'wealthbar';
}

export const BRAND = getBrand(window.process);

export function getBrandFullName(brand) {
  if (brand === 'assante') {
    return isFrench() ? process.env.WHITELABEL_FULL_NAME_FR || 'Assante Connecté' : process.env.WHITELABEL_FULL_NAME || 'Assante Connect';
  }
  return isFrench() ? process.env.WHITELABEL_FULL_NAME_FR || 'Investissement direct CI' : process.env.WHITELABEL_FULL_NAME || 'CI Direct Investing';
}

export const BRAND_FULL_NAME = getBrandFullName(BRAND);
